export function cycleArr<T>(a: number, am: Array<T>):T{
    return a>=0?am[a%am.length]:am[am.length-(1+ -(a+1)%(am.length))]
}

export function cycle(a: number, am: number){
    return a>=0?a%am:am-(1+ -(a+1)%am)
}